export enum OrderStatusEnum {
  REGISTRO = "REGISTRO",
  COMPLEMENTACION = "COMPLEMENTACION",
  FIN = "FIN"
};

export enum InstrumentValidationEnum {
  V1 = "V1",
  V2 = "V2",
  V3 = "V3",
  V4 = "V4",
};

export enum OrderTypeEnum { COMPRA = "COMPRA", VENTA = "VENTA" };
export enum LimitTypeEnum { MERCADO = "MERCADO", LIMITE = "LIMITE" };

export interface Portfolio {
  id: string;
  name: string;
  nit: string;
  dv: number;
  decevalAccount: number;
  DCVAccount: number;
}

export interface Instrument {
  id: string;
  mnemonic: string;
  instrumentType: string;
  isin: string;
  currency: string;
  interestRate: string;
  frequency: string;
  issuanceDate: string;
  maturityDate: string;
  issuerName: string;
  rating: string;
  validation: string;
};

export interface ResponseInstruments {
  success: boolean;
  data?: Instrument[];
  error?: string;
  message?: string;
}

export interface Rate {
  id: string;
  instrumentId: string;
  rate: number;
  price: number;
};

export interface Share {
  id: string;
  mnemonic: string;
  isin: string;
  issuerName: string;
}

export interface ResponseShares {
  success: boolean;
  data?: Share[];
  error?: string;
  message?: string;
}

export interface ResponseRates {
  success: boolean;
  data?: Rate[];
  error?: string;
  message?: string;
}

export interface OrderEntity {
  id: string;
  orderType: OrderTypeEnum;
  status: OrderStatusEnum;
  instrument: Instrument;
  portfolio: Portfolio;
  quantity: number;
  rate: number;
  value: number;
  createdAt: Date;
  updatedAt: Date | null;
  confirmNumber?: string;
}

export interface VariableOrderEntity {
  id: string;
  orderType: OrderTypeEnum;
  status: OrderStatusEnum;
  instrument: Instrument;
  portfolio: Portfolio;
  quantity: number;
  limitPrice: number;
  limitType: LimitTypeEnum;
  value: number;
  createdAt: Date;
  updatedAt: Date | null;
  confirmNumber?: string;
}

export interface OrderEntityKV {
  id: string;
  orderType: string;
  status: string;
  portfolio: string;
  instrument: string;
  quantity: number;
  rate: number;
  value: number;
  createdAt: Date;
  updatedAt: Date | null;
  confirmNumber?: string;
}

export interface VariableOrderEntityKV {
  id: string;
  orderType: string;
  status: string;
  portfolio: string;
  instrument: string;
  quantity: number;
  limitPrice: number;
  limitType: string;
  value: number;
  createdAt: Date;
  updatedAt: Date | null;
  confirmNumber?: string;
}

export interface OrderCreateRequest {
  portfolio: string;
  orderType: string;
  instrument: string;
  quantity: number;
  rate: number;
  value: number;
  status?: string;
  confirmNumber?: string;
}

export interface VariableOrderCreateRequest {
  portfolio: string;
  orderType: string;
  instrument: string;
  quantity: number;
  limitPrice: number;
  limitType: string;
  value: number;
  status?: string;
  confirmNumber?: string;
}

export interface OrderUpdateRequest {
  id: string;
  portfolio: string;
  orderType: string;
  instrument: string;
  quantity: number;
  rate: number;
  value: number;
  status?: string;
  confirmNumber?: string;
}

export interface VariableOrderUpdateRequest {
  id: string;
  portfolio: string;
  orderType: string;
  instrument: string;
  quantity: number;
  limitPrice: number;
  limitType: string;
  value: number;
  status?: string;
  confirmNumber?: string;
}

export interface ResponseOrder {
  success: boolean;
  data?: OrderEntity[];
  error?: string;
  message?: string;
}

export interface ResponseVariableOrder {
  success: boolean;
  data?: VariableOrderEntity[];
  error?: string;
  message?: string;
}

export interface ResponseOrderKV {
  success: boolean;
  data?: OrderEntityKV[];
  error?: string;
  message?: string;
}

export interface ResponseVariableOrderKV {
  success: boolean;
  data?: VariableOrderEntityKV[];
  error?: string;
  message?: string;
}

export interface ResponsePortfolios {
  success: boolean;
  data?: Portfolio[];
  error?: string;
  message?: string;
}